import { getLocalApi } from "./localApi";
import { BathroomType} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllBathroomTypes() : Promise<BathroomType[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_bathroom_types, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch bathroom types')
}